import { render, staticRenderFns } from "./WasteDiversion.vue?vue&type=template&id=1d75bda3&scoped=true&"
import script from "./WasteDiversion.vue?vue&type=script&lang=js&"
export * from "./WasteDiversion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d75bda3",
  null
  
)

export default component.exports